"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownWrapper = exports.StyledButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const oxygen_button_1 = __importDefault(require("@8x8/oxygen-button"));
exports.StyledButton = (0, styled_components_1.default)(oxygen_button_1.default) `
  display: inline-flex;
  align-items: center;
  ${({ invertItems }) => invertItems && 'flex-flow: row-reverse'}
`;
exports.DropdownWrapper = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.dropdownOffset};

  padding: ${({ theme }) => theme.dropdownPadding};
  border: 1px solid ${({ theme }) => theme.dropdownBorderColor};
  border-radius: ${({ theme }) => theme.dropdownBorderRadius};

  box-shadow: ${({ theme }) => theme.dropdownShadowSize}
    ${({ theme }) => theme.dropdownShadowColor};
  background: ${({ theme }) => theme.dropdownBackgroundColor};

  overflow: hidden;
  z-index: ${({ theme }) => theme.dropdownZIndex};
`;
exports.default = exports.DropdownWrapper;
